import { useState, useEffect } from "react";
import styles from "./Tools.module.scss";
import { useTranslation } from "react-i18next";
import TradingViewWidget from "../../components/ForexMap.jsx";
import StockMap from "../../components/StockMap.jsx";
import ETFMap from "../../components/ETFMap.jsx";
import CryptoCoinMap from "../../components/CryptoCoinMap.jsx";
import CryptoMarketWidget from "../../components/CryptoMarket.jsx";
import CalendarWidget from "../../components/CalendarWidget.jsx";
import TopStoriesWidget from "../../components/TopStories.jsx";
import { Link, useLocation, useParams } from "react-router-dom";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import Gradient from "../../imgs/gradient.svg";

export default function Tools() {
  const { t } = useTranslation();
  const [selectedTool, setSelectedTool] = useState("forexHeatMap");
  const { type } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (type) {
      setSelectedTool(type);
    }
  }, [pathname, type]);

  console.log(selectedTool);

  const tools = [
    {
      id: 1,
      name: t("Forex Heat-map"),
      widgetType: "forexHeatMap",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_906_18152)">
            <circle cx="7.99967" cy="8" r="6.66667" stroke="#FCFCFC" />
            <path
              d="M4.33301 2.66674L9.25193 8.00007V5.00007"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.5859 13.2523L6.58594 7.99997V11"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_906_18152">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 2,
      name: t("Heat-map of the stock"),
      widgetType: "stockHeatMap",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M7.02089 2.59383C7.3968 2.27348 7.58476 2.1133 7.78128 2.01937C8.23581 1.80213 8.76421 1.80213 9.21874 2.01937C9.41526 2.1133 9.60321 2.27348 9.97913 2.59383C10.1287 2.72133 10.2036 2.78508 10.2834 2.83863C10.4666 2.96138 10.6723 3.04658 10.8886 3.08928C10.9829 3.10791 11.0809 3.11573 11.2768 3.13136C11.7692 3.17065 12.0154 3.1903 12.2207 3.26284C12.6957 3.43062 13.0694 3.80426 13.2372 4.27928C13.3097 4.48466 13.3294 4.73082 13.3686 5.22316C13.3843 5.41911 13.3921 5.51709 13.4107 5.61144C13.4534 5.82774 13.5386 6.03342 13.6614 6.21656C13.7149 6.29646 13.7787 6.37126 13.9062 6.52088C14.2265 6.89679 14.3867 7.08475 14.4806 7.28127C14.6979 7.7358 14.6979 8.2642 14.4806 8.71873C14.3867 8.91525 14.2265 9.10321 13.9062 9.47912C13.7787 9.62874 13.7149 9.70354 13.6614 9.78344C13.5386 9.96658 13.4534 10.1723 13.4107 10.3886C13.3921 10.4829 13.3843 10.5809 13.3686 10.7768C13.3294 11.2692 13.3097 11.5153 13.2372 11.7207C13.0694 12.1957 12.6957 12.5694 12.2207 12.7372C12.0154 12.8097 11.7692 12.8293 11.2768 12.8686C11.0809 12.8843 10.9829 12.8921 10.8886 12.9107C10.6723 12.9534 10.4666 13.0386 10.2834 13.1614C10.2036 13.2149 10.1287 13.2787 9.97913 13.4062C9.60321 13.7265 9.41526 13.8867 9.21874 13.9806C8.76421 14.1979 8.23581 14.1979 7.78128 13.9806C7.58476 13.8867 7.3968 13.7265 7.02089 13.4062C6.87127 13.2787 6.79646 13.2149 6.71657 13.1614C6.53343 13.0386 6.32775 12.9534 6.11145 12.9107C6.01709 12.8921 5.91912 12.8843 5.72317 12.8686C5.23083 12.8293 4.98466 12.8097 4.77929 12.7372C4.30427 12.5694 3.93063 12.1957 3.76285 11.7207C3.69031 11.5153 3.67066 11.2692 3.63137 10.7768C3.61574 10.5809 3.60792 10.4829 3.58929 10.3886C3.54659 10.1723 3.46139 9.96658 3.33864 9.78344C3.28509 9.70354 3.22134 9.62874 3.09384 9.47912C2.77349 9.10321 2.61331 8.91525 2.51938 8.71873C2.30213 8.2642 2.30213 7.7358 2.51938 7.28127C2.61331 7.08475 2.77349 6.89679 3.09384 6.52088C3.22134 6.37126 3.28509 6.29646 3.33864 6.21656C3.46139 6.03342 3.54659 5.82774 3.58929 5.61144C3.60792 5.51709 3.61574 5.41911 3.63137 5.22316C3.67066 4.73082 3.69031 4.48466 3.76285 4.27928C3.93063 3.80426 4.30427 3.43062 4.77929 3.26284C4.98466 3.1903 5.23083 3.17065 5.72317 3.13136C5.91912 3.11573 6.01709 3.10791 6.11145 3.08928C6.32775 3.04658 6.53343 2.96138 6.71657 2.83863C6.79646 2.78508 6.87127 2.72133 7.02089 2.59383Z"
            stroke="#FCFCFC"
          />
          <path d="M6.5 10L10.5 6" stroke="#FCFCFC" stroke-linecap="round" />
          <path
            d="M10.8333 9.66667C10.8333 10.0349 10.5349 10.3333 10.1667 10.3333C9.79848 10.3333 9.5 10.0349 9.5 9.66667C9.5 9.29848 9.79848 9 10.1667 9C10.5349 9 10.8333 9.29848 10.8333 9.66667Z"
            fill="#FCFCFC"
          />
          <path
            d="M7.50033 6.33333C7.50033 6.70152 7.20185 7 6.83366 7C6.46547 7 6.16699 6.70152 6.16699 6.33333C6.16699 5.96514 6.46547 5.66666 6.83366 5.66666C7.20185 5.66666 7.50033 5.96514 7.50033 6.33333Z"
            fill="#FCFCFC"
          />
        </svg>
      ),
    },
    {
      id: 3,
      name: t("ETF Heat-map"),
      widgetType: "etfHeatMap",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_906_18171)">
            <path
              d="M14.6663 14.6667H7.99967C4.85698 14.6667 3.28563 14.6667 2.30932 13.6904C1.33301 12.714 1.33301 11.1427 1.33301 8V1.33334"
              stroke="#FCFCFC"
              stroke-linecap="round"
            />
            <path
              d="M12.6668 4.66666L10.5881 7.28427C10.2697 7.68522 10.1105 7.8857 9.92771 7.98341C9.64669 8.13365 9.31089 8.14095 9.0236 8.00308C8.83675 7.91342 8.66898 7.72005 8.33344 7.33332C7.9979 6.9466 7.83012 6.75323 7.64328 6.66356C7.35599 6.5257 7.0202 6.533 6.73918 6.68323C6.55641 6.78093 6.3972 6.98141 6.07879 7.38235L4 10"
              stroke="#FCFCFC"
              stroke-linecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_906_18171">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 4,
      name: t("Crypto Coin Heat-map"),
      widgetType: "CryptoHeatMap",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <circle cx="8.49967" cy="8" r="6.66667" stroke="#FCFCFC" />
          <circle cx="8.49967" cy="8" r="2.66667" stroke="#FCFCFC" />
        </svg>
      ),
    },
    // {
    //     id:5,
    //     name: t('Technical Analysis'),
    //     widgetType: 'technicalAnalysis',
    //     icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    //     <g clip-path="url(#clip0_906_18181)">
    //       <path d="M14.6663 14.6667H1.33301" stroke="#FCFCFC" stroke-linecap="round"/>
    //       <path d="M14 14.6667V9.66666C14 9.11438 13.5523 8.66666 13 8.66666H11C10.4477 8.66666 10 9.11438 10 9.66666V14.6667" stroke="#FCFCFC"/>
    //       <path d="M10 14.6667V3.33334C10 2.39053 10 1.91912 9.70711 1.62623C9.41421 1.33334 8.94281 1.33334 8 1.33334C7.05719 1.33334 6.58579 1.33334 6.29289 1.62623C6 1.91912 6 2.39053 6 3.33334V14.6667" stroke="#FCFCFC"/>
    //       <path d="M6 14.6667V6.33334C6 5.78105 5.55228 5.33334 5 5.33334H3C2.44772 5.33334 2 5.78105 2 6.33334V14.6667" stroke="#FCFCFC"/>
    //     </g>
    //     <defs>
    //       <clipPath id="clip0_906_18181">
    //         <rect width="16" height="16" fill="white"/>
    //       </clipPath>
    //     </defs>
    //   </svg>
    // },
    {
      id: 6,
      name: t("Cryptocurrency Market"),
      widgetType: "cryptocurrencyMarket",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M15.1663 7V8C15.1663 11.1427 15.1663 12.714 14.19 13.6904C13.2137 14.6667 11.6424 14.6667 8.49967 14.6667C5.35698 14.6667 3.78563 14.6667 2.80932 13.6904C1.83301 12.714 1.83301 11.1427 1.83301 8C1.83301 4.85731 1.83301 3.28596 2.80932 2.30965C3.78563 1.33334 5.35698 1.33334 8.49967 1.33334H9.49967"
            stroke="#FCFCFC"
            stroke-linecap="round"
          />
          <circle cx="13.167" cy="3.33334" r="2" stroke="#FCFCFC" />
          <path
            d="M5.16699 9.33333L6.69559 7.80474C6.95594 7.54439 7.37805 7.54439 7.6384 7.80474L8.69559 8.86193C8.95594 9.12228 9.37805 9.12228 9.6384 8.86193L11.8337 6.66666M11.8337 6.66666V8.33333M11.8337 6.66666H10.167"
            stroke="#FCFCFC"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 7,
      name: t("Economic Calendar"),
      widgetType: "economicCalendar",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M1.33301 8C1.33301 5.48584 1.33301 4.22876 2.11406 3.44771C2.89511 2.66666 4.15218 2.66666 6.66634 2.66666H9.33301C11.8472 2.66666 13.1042 2.66666 13.8853 3.44771C14.6663 4.22876 14.6663 5.48584 14.6663 8V9.33333C14.6663 11.8475 14.6663 13.1046 13.8853 13.8856C13.1042 14.6667 11.8472 14.6667 9.33301 14.6667H6.66634C4.15218 14.6667 2.89511 14.6667 2.11406 13.8856C1.33301 13.1046 1.33301 11.8475 1.33301 9.33333V8Z"
            stroke="#FCFCFC"
          />
          <path
            d="M4.66699 2.66666V1.66666"
            stroke="#FCFCFC"
            stroke-linecap="round"
          />
          <path
            d="M11.333 2.66666V1.66666"
            stroke="#FCFCFC"
            stroke-linecap="round"
          />
          <path
            d="M1.66699 6H14.3337"
            stroke="#FCFCFC"
            stroke-linecap="round"
          />
          <path
            d="M12.0003 11.3333C12.0003 11.7015 11.7018 12 11.3337 12C10.9655 12 10.667 11.7015 10.667 11.3333C10.667 10.9651 10.9655 10.6667 11.3337 10.6667C11.7018 10.6667 12.0003 10.9651 12.0003 11.3333Z"
            fill="#FCFCFC"
          />
          <path
            d="M12.0003 8.66667C12.0003 9.03486 11.7018 9.33333 11.3337 9.33333C10.9655 9.33333 10.667 9.03486 10.667 8.66667C10.667 8.29848 10.9655 8 11.3337 8C11.7018 8 12.0003 8.29848 12.0003 8.66667Z"
            fill="#FCFCFC"
          />
          <path
            d="M8.66634 11.3333C8.66634 11.7015 8.36786 12 7.99967 12C7.63148 12 7.33301 11.7015 7.33301 11.3333C7.33301 10.9651 7.63148 10.6667 7.99967 10.6667C8.36786 10.6667 8.66634 10.9651 8.66634 11.3333Z"
            fill="#FCFCFC"
          />
          <path
            d="M8.66634 8.66667C8.66634 9.03486 8.36786 9.33333 7.99967 9.33333C7.63148 9.33333 7.33301 9.03486 7.33301 8.66667C7.33301 8.29848 7.63148 8 7.99967 8C8.36786 8 8.66634 8.29848 8.66634 8.66667Z"
            fill="#FCFCFC"
          />
          <path
            d="M5.33333 11.3333C5.33333 11.7015 5.03486 12 4.66667 12C4.29848 12 4 11.7015 4 11.3333C4 10.9651 4.29848 10.6667 4.66667 10.6667C5.03486 10.6667 5.33333 10.9651 5.33333 11.3333Z"
            fill="#FCFCFC"
          />
          <path
            d="M5.33333 8.66667C5.33333 9.03486 5.03486 9.33333 4.66667 9.33333C4.29848 9.33333 4 9.03486 4 8.66667C4 8.29848 4.29848 8 4.66667 8C5.03486 8 5.33333 8.29848 5.33333 8.66667Z"
            fill="#FCFCFC"
          />
        </svg>
      ),
    },
    {
      id: 8,
      name: t("Top Stories"),
      widgetType: "topStories",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M3.83301 5.33334C3.83301 3.44772 3.83301 2.50491 4.41879 1.91912C5.00458 1.33334 5.94739 1.33334 7.83301 1.33334H9.16634C11.052 1.33334 11.9948 1.33334 12.5806 1.91912C13.1663 2.50491 13.1663 3.44772 13.1663 5.33334V10.6667C13.1663 12.5523 13.1663 13.4951 12.5806 14.0809C11.9948 14.6667 11.052 14.6667 9.16634 14.6667H7.83301C5.94739 14.6667 5.00458 14.6667 4.41879 14.0809C3.83301 13.4951 3.83301 12.5523 3.83301 10.6667V5.33334Z"
            stroke="#FCFCFC"
          />
          <path
            d="M3.83301 2.71745C3.18295 2.78139 2.74539 2.92589 2.41879 3.25249C1.83301 3.83827 1.83301 4.78108 1.83301 6.6667V9.33337C1.83301 11.219 1.83301 12.1618 2.41879 12.7476C2.74539 13.0742 3.18295 13.2187 3.83301 13.2826"
            stroke="#FCFCFC"
          />
          <path
            d="M13.167 2.71745C13.817 2.78139 14.2546 2.92589 14.5812 3.25249C15.167 3.83827 15.167 4.78108 15.167 6.6667V9.33337C15.167 11.219 15.167 12.1618 14.5812 12.7476C14.2546 13.0742 13.817 13.2187 13.167 13.2826"
            stroke="#FCFCFC"
          />
          <path d="M6.5 8.66666H10.5" stroke="#FCFCFC" stroke-linecap="round" />
          <path d="M6.5 6H10.5" stroke="#FCFCFC" stroke-linecap="round" />
          <path d="M6.5 11.3333H8.5" stroke="#FCFCFC" stroke-linecap="round" />
        </svg>
      ),
    },
  ];

  const renderWidget = () => {
    if (
      selectedTool === "forexHeatMap" ||
      window.location.pathname === "/tools/forexHeatMap"
    ) {
      return <TradingViewWidget />;
    } else if (
      selectedTool === "stockHeatMap" ||
      window.location.pathname === "/tools/stockHeatMap"
    ) {
      return <StockMap />;
    } else if (
      selectedTool === "etfHeatMap" ||
      window.location.pathname === "/tools/etfHeatMap"
    ) {
      return <ETFMap />;
    } else if (
      selectedTool === "CryptoHeatMap" ||
      window.location.pathname === "/tools/CryptoHeatMap"
    ) {
      return <CryptoCoinMap />;
    } else if (
      selectedTool === "cryptocurrencyMarket" ||
      window.location.pathname === "/tools/cryptocurrencyMarket"
    ) {
      return <CryptoMarketWidget />;
    } else if (
      selectedTool === "economicCalendar" ||
      window.location.pathname === "/tools/economicCalendar"
    ) {
      return <CalendarWidget />;
    } else if (
      selectedTool === "topStories" ||
      window.location.pathname === "/tools/topStories"
    ) {
      return <TopStoriesWidget />;
    }
    return null;
  };

  return (
    <div className={styles.tools_page}>
      <Header />
      <div className={styles.header}>
      {/* <img className={styles.gradient} src={Gradient} alt="gradient" /> */}
        <h1>{t("Trades ")}<span>{t("Tools")}</span></h1>
        {/* <p>
          {t(
            "Preparation first, then action. This is how you make the best trades"
          )}
        </p> */}
      </div>
      <div className={styles.body}>
        <div className={styles.tools_list}>
          {tools.map((el) => (
            <Link
              to={`/tools/${el.widgetType}`}
              key={el.id}
              className={`${styles.tool} ${
                selectedTool === el.widgetType &&
                window.location.pathname === `/tools/${selectedTool}`
                  ? styles.active
                  : ""
              }`}
              onClick={() => setSelectedTool(el.widgetType)}
              style={{ textDecoration: "none" }}
            >
              {el.icon}
              <h2>{el.name}</h2>
            </Link>
          ))}
        </div>
        <div className={styles.widget}>{renderWidget()}</div>
      </div>
      <Footer />
    </div>
  );
}
